<template>
  <div>
    <h2>Order Summary</h2>

    <div class="m-slide-section">
      <div class="title">
        <h4>Target Area</h4>
        <b-link @click="goGeo" class="title-edit">Edit</b-link>
      </div>
      <m-slide-item :items="geos" :canDelete = "false"/>
    </div>

    <div class="m-slide-section">
      <div class="title">
        <h4>Target Audience</h4>
        <b-link @click="goDemo" class="title-edit">Edit</b-link>
      </div>
      <m-slide-item :items="demos" :canDelete = "false"/>
    </div>

    <div class="m-slide-section">
      <h4>Count & Quote</h4>
      <p class="item">Selected/Available <br />
      {{order.TotalDesiredQty | numberFormat('', 0)}} / {{order.TotalAvailableQty | numberFormat('', 0)}}</p>
      <p class="item" v-if="$store.getters['summary/rewardsPoint'] > 0">Earned Points:
        <span class="color-primary">{{$store.getters['summary/rewardsPoint'] | numberFormat('', 0)}}</span></p>
      <!--<p class="item" v-if="$store.getters['summary/bonusPoint'] > 0">Earned Bonus Points:-->
        <!--<span class="color-primary">{{$store.getters['summary/bonusPoint'] | numberFormat('', 0)}}</span></p>-->
      <p class="item">Order Total: <span class="primary">{{order.TotalEstmCost | numberFormat}} + Tax</span></p>
      <!--<p class="item">-->
        <!--{{site.termsBrief}}-->
      <!--</p>-->

    </div>
  </div>
</template>

<script>
  import MSlideItem from '@/components/slide/MSlideItem.vue'

  export default {
    components: {
      MSlideItem
    },
    data () {
      return {
        geoTitle: {
          zip: 'Zip Codes'
        }
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      site () {
        return this.$store.state.site
      },
      demos () {
        return this.$store.getters['order/demos']
      },
      geos () {
        return this.$store.getters['order/geos']
      },
      currentGeoType () {
        return this.$store.getters['order/currentGeoType']
      }
    },
    methods: {
      goDemo () {
        this.$router.push({name: 'demo'})
      },
      goGeo () {
        if (this.currentGeoType.routeName) {
          this.$router.push({name: 'geo'})
        } else {
          let geoType = this.currentGeoType.name
          if (this.currentGeoType.title === 'Radius') {
            geoType = 'radius'
          }
          this.$router.push({name: 'geo-' + geoType})
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .item {
    margin-bottom: 8px;
  }
  .title {
    display: flex;
    justify-content: space-between;
  }
  .title-edit {
    margin-left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/slide/MSlideSummary.vue